import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { CalendarComponent } from './calendar.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [CalendarComponent],
  imports: [CommonModule, CalendarModule, FormsModule, ReactiveFormsModule],
  exports: [CalendarModule, CalendarComponent],
})
export class CalendarComponentModule {}
